<template>
    <div id="uploadDoc">
        <el-upload class="upload-demo" :drag="drag" action="/" :multiple="multiple" :http-request="uploadFile" :show-file-list="false">
            <div v-if="uploadStyle=='default'">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{footnote}}，或<em>点击上传</em></div>
                <div class="el-upload__text">只能上传{{backString(allowFileType)}}文件</div>
            </div>
            <div v-else>
                <slot></slot>
            </div>
        </el-upload>
        <div v-if="multiple">
            <p class="fileList" v-for="(item,index) in fileList">
                <span :title="item.name">
                     <i class="el-icon-document"></i>
                    <a href="javascript:void(0)" class="fileName">{{item.name}}</a>
                </span>
                <i class="close el-icon-circle-close" @click="removeFile(index)" title="删除"></i>
            </p>
        </div>
        <div v-else>
            <p class="fileList" v-if="fileList">
                <span :title="fileList.name">
                    <i class="el-icon-document"></i>
                    <a href="javascript:void(0)" class="fileName">{{fileList.name}}</a>
                </span>
                <i class="close el-icon-circle-close" @click="removeFile(-1)" title="删除"></i>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "uploadFile",
        props:{
            uploadStyle:{
                default: "default", type:String,
            },
            drag:{default:true, type:Boolean},
            multiple:Boolean,
            allowFileType:{
                default: ()=>{
                    return ["doc", "docx", "xlsx", "zip", "rar"]
                }
            },
            allowFileSize:{
                default:52428800
            },
            footnote:{
                default: `将审核通过文件拖到此处，或<em>点击上传</em>`
            },
        },
        data(){
            return{
                fileList:[]
            }
        },
        methods:{
            backString(item){
                let str = ""
                item.forEach(i=>{
                    str = str + i + "、"
                })
                return str.substring(0, str.length-1)
            },
            uploadFile(fileObj){
                let file = fileObj.file;
                // 文件格式
                let allowFleType = this.allowFileType;
                let uploadFileType = file.name.substring(file.name.lastIndexOf('.')+1, file.name.length);
                if(allowFleType.indexOf(uploadFileType) <= -1){
                    this.$message.error(`${uploadFileType}格式的文件不受支持，请上传：${this.allowFileType}文件`);
                    return false
                }
                // 文件大小
                // const fileSize = file.size;
                // if(fileSize > this.allowFileSize){
                //     this.$message.error(`仅支持${this.allowFileSize/1024/1024}MB以内的文件，请重新上传`);
                //     return false
                // }
                if(this.multiple){
                    this.fileList.push({file:file, name:file.name});
                }else{
                    this.fileList = {file:file, name:file.name};
                }
                // 与父组件同步上传文件信息
                this.$emit("changeUploadEvent", this.fileList)
            },
            // 删除文件
            removeFile(index){
                if(index>=0){
                    this.fileList.splice(index, 1);
                }else {
                    this.fileList = ''
                }
                // 与父组件同步上传文件信息
                this.$emit("changeUploadEvent", this.fileList)
            }
        },
        mounted() {
            this.fileList = this.multiple ? [] : '';
        }
    }
</script>

<style scoped>
    #uploadDoc{
        width: 360px;
    }
    .fileList{
        width: 96%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 3px 5px;
        font-size: 14px;
    }
    .fileList > span {
        display: flex;
        align-items: center;
    }
    .fileList> i{
        color: #999;
    }
    .fileName{
        margin-left: 5px;
        color: #606266;
        letter-spacing: .5px;
        overflow: hidden;
        text-wrap: none;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 320px;
        display: inline-block;
    }
    .close{
        display: none;
        cursor: pointer;
        font-size: 15px;
    }
    .close:hover{
        color: #67c23a;
    }
    .fileList:hover {
        background-color: #f6f6f6;
        border-radius: 2px;
    }
    .close{
        display: inline-block;
    }
    .close > span .fileName{
        color: #0755a2;
    }
    .uploadBlock .upload-demo >>> .el-upload{
        width: 100%;
        height: 36px;
        border: 1px solid #DCDFE6;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 3px;
    }
    .uploadBlock .upload-demo >>> .el-upload:focus{
        color: #000;
    }
</style>
